import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const styles: moduleStyleType = {
    loadMoreButton: {
        mt: 2,
    },
    paginationConatiner: {
        mt: 2,
    },
}
